/* =========================================================================
   HOLY SPIRIT 2.0 - LUXURY MOTION SYSTEM (runtime) - Fase 5
   -------------------------------------------------------------------------
   100% aditivo y defensivo. Si un elemento no existe, no hace nada.
   1) Scroll reveal reutilizable (.lux-reveal -> .is-in) via IntersectionObserver
   2) Parallax de puntero muy sutil para capas decorativas ([data-lux-parallax])
   Respeta prefers-reduced-motion: revela todo al instante y no aplica parallax.
   ========================================================================= */
(function () {
  'use strict';

  var reduce = false;
  try {
    reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { reduce = false; }

  /* ---------------------------------------------------------------------
     1. SCROLL REVEAL
     --------------------------------------------------------------------- */
  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.lux-reveal');
    if (!nodes.length) return;

    // Sin soporte o movimiento reducido: mostrar todo, sin animar.
    if (reduce || typeof IntersectionObserver === 'undefined') {
      revealAll(nodes);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var en = entries[i];
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          obs.unobserve(en.target);
        }
      }
    }, { root: null, rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  /* ---------------------------------------------------------------------
     2. PARALLAX DE PUNTERO (muy sutil, solo puntero fino / desktop)
     Cada elemento con [data-lux-parallax="<factor>"] se desplaza una
     fraccion del movimiento del cursor. Factor tipico 6-20 (px maximos).
     --------------------------------------------------------------------- */
  function initParallax() {
    if (reduce) return;
    var fine = true;
    try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { fine = true; }
    if (!fine) return;

    var layers = document.querySelectorAll('[data-lux-parallax]');
    if (!layers.length) return;

    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;

    function onMove(ev) {
      var w = window.innerWidth || 1, h = window.innerHeight || 1;
      // -0.5 .. 0.5
      tx = (ev.clientX / w) - 0.5;
      ty = (ev.clientY / h) - 0.5;
      if (!raf) raf = window.requestAnimationFrame(apply);
    }

    function apply() {
      raf = null;
      // easing suave hacia el objetivo
      cx += (tx - cx) * 0.06;
      cy += (ty - cy) * 0.06;
      for (var i = 0; i < layers.length; i++) {
        var f = parseFloat(layers[i].getAttribute('data-lux-parallax')) || 10;
        layers[i].style.transform = 'translate3d(' + (cx * f).toFixed(2) + 'px,' + (cy * f).toFixed(2) + 'px,0)';
      }
      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) {
        raf = window.requestAnimationFrame(apply);
      }
    }

    window.addEventListener('mousemove', onMove, { passive: true });
  }

  function init() {
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
